import { add, qs, qsa, remove, listen } from "@fluorescent/dom";
import Delegate from "ftdomdelegate";
import { createFocusTrap } from "focus-trap";

import { on } from "@/neon/events";
import productForm from "@/components/productForm";
import {
  optionButtons,
  quantityInput,
  variantAvailability,
} from "@/lib/product";
import { dispatchCustomEvent, CustomEvents } from "@/lib/dispatch-custom-event";
import { animateQuickAdd } from "@/lib/animation";

const selectors = {
  addToCart: "[data-add-to-cart]",
  price: "[data-price]",
  comparePrice: "[data-compare-price]",
  quickAddModal: "[data-quick-add-modal]",
  quickAddModalClose: "[data-quick-add-close]",
  quickAddModalInner: ".quick-add__inner",
  quickAddModalContent: ".quick-add__content",
  quickAddModalWash: ".quick-add__wash",
  quickAddProduct: ".quick-add__product-wrapper",
};

const classes = {
  visible: "visible",
  hidden: "hidden",
  loaded: "loaded",
};

const getProductMarkup = handle => cb =>
  fetch(
    `${window.theme.routes.products}/${encodeURIComponent(
      handle
    )}?section_id=quick-add-item`
  )
    .then(res => res.text())
    .then(data => cb(data))
    .catch(err => console.log(err.message));

export default function () {
  const quickAddModal = qs(selectors.quickAddModal, document);
  const quickAddModalContent = qs(
    selectors.quickAddModalContent,
    quickAddModal
  );
  const quickAddModalWash = qs(selectors.quickAddModalWash, quickAddModal);
  const delegate = new Delegate(document.body);
  const listeners = [
    listen(quickAddModalWash, "click", close),
    listen(qs(selectors.quickAddModalClose, quickAddModal), "click", close),
    listen(quickAddModal, "keydown", ({ keyCode }) => {
      if (keyCode === 27) close();
    }),
    on("product:added", () => close()),
  ];
  delegate.on("click", "button[data-quick-add]", handleClick);
  const focusTrap = createFocusTrap(
    qs(selectors.quickAddModalInner, quickAddModal),
    {
      allowOutsideClick: true,
    }
  );
  let form,
    specialityVariantButtons,
    quanityInputEl,
    dynamicVariantAvailability;

  const quickAddAnimation = animateQuickAdd(quickAddModal);

  function handleClick(event, target) {
    event.preventDefault();
    const { quickAdd: handle } = target.dataset;

    open(handle);
  }

  function open(handle) {
    quickAddModalContent.innerHTML = "";
    add(quickAddModal, classes.visible);
    focusTrap.activate();

    // Fetch markup and open quick add
    const product = getProductMarkup(handle);
    product(html => {
      let container = document.createElement("div");
      container.innerHTML = html;

      quickAddModalContent.innerHTML = qs(
        selectors.quickAddProduct,
        container
      ).innerHTML;

      form = productForm(qs("form", quickAddModalContent), {
        isProductPage: false,
        container: quickAddModalContent,
      });

      const quantityEl = qs(".product-form__input", quickAddModalContent);

      if (quantityEl) {
        quanityInputEl = quantityInput(
          ".product-form__quantity",
          quickAddModalContent
        );
      }

      specialityVariantButtons = optionButtons(
        qsa("[data-option-buttons]", quickAddModalContent)
      );

      // Handle dynamic variant options
      dynamicVariantAvailability = variantAvailability(quickAddModalContent);
      dispatchCustomEvent(CustomEvents.quickViewLoaded);

      add(quickAddModal, classes.loaded);
      quickAddAnimation?.open();
    });
  }

  function close() {
    focusTrap.deactivate();
    remove(quickAddModal, classes.loaded);
    remove(quickAddModal, classes.visible);
    form?.unload();
    quanityInputEl?.quanityInputEl();
    specialityVariantButtons?.destroy();
    dynamicVariantAvailability?.unload();
    quickAddAnimation?.close();
  }
}
